import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const ConfirmDialog = ({ open, onClose, onConfirm, title, description, confirmLabel, cancelLabel, confirmClassName }) => (
  <Dialog open={open} onOpenChange={onClose}>
    <DialogContent className="rounded-2xl" data-testid="confirm-dialog" aria-describedby={undefined}>
      <DialogHeader>
        <DialogTitle className="font-heading">{title}</DialogTitle>
      </DialogHeader>
      <p className="text-sm text-slate-600 py-2" data-testid="confirm-dialog-text">{description}</p>
      <div className="flex gap-3 justify-end pt-2">
        <Button variant="outline" data-testid="confirm-dialog-cancel" onClick={onClose} className="rounded-full">{cancelLabel}</Button>
        <Button data-testid="confirm-dialog-confirm" onClick={onConfirm} className={`rounded-full text-white ${confirmClassName || "bg-destructive hover:bg-destructive/90"}`}>{confirmLabel}</Button>
      </div>
    </DialogContent>
  </Dialog>
);
